import { useState } from 'react';
import { Alert, Button, Form, Input, InputNumber, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';
import ApiService from '../../core/service/api-service';

// Varsayılan öne çekme miktarı. Kullanıcı isterse azaltıp artırabilir.
const DEFAULT_MINUTES = 20;

// Acil öncelik: study_detail.timeout_date değerini girilen dakika kadar öne çeker,
// yani raporun teslim süresi kısalır. Süre sonu olmayan çekimde anlamı yok.
export default function StudySetPriorityModal({ studyRow, onSaved, onCancel }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [minutes, setMinutes] = useState(DEFAULT_MINUTES);

    const currentTimeout = studyRow?.studyTimeoutDate
        ? moment(studyRow.studyTimeoutDate)
        : null;
    const newTimeout = currentTimeout
        ? moment(currentTimeout).subtract(minutes || 0, 'minutes')
        : null;

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const response = await ApiService.StudyDetails.SetPriority({
                studyIdList: [studyRow.id],
                minutes: values.minutes,
                description: values.description,
            });

            if (response.success) {
                onSaved && onSaved();
            }
        } finally {
            setLoading(false);
        }
    };

    const dateText = (value) =>
        value ? value.local().format('DD.MM.YYYY HH:mm') : '-';

    return (
        <Form
            form={form}
            layout="vertical"
            style={{ padding: '16px 0' }}
            initialValues={{ minutes: DEFAULT_MINUTES }}
        >
            {!currentTimeout && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 16 }}
                    message={t('This study has no timeout date')}
                />
            )}

            <div style={{ marginBottom: 16, fontSize: 13 }}>
                <div>
                    {t('Current Timeout')}: <b>{dateText(currentTimeout)}</b>
                </div>
                <div>
                    {t('New Timeout')}: <b>{dateText(newTimeout)}</b>
                </div>
            </div>

            <Form.Item
                name="minutes"
                label={t('Pull Forward (minutes)')}
                rules={[
                    {
                        required: true,
                        message: t('Please enter minutes'),
                    },
                ]}
            >
                <InputNumber
                    min={1}
                    max={1440}
                    style={{ width: 160 }}
                    onChange={(value) => setMinutes(value)}
                />
            </Form.Item>

            <Form.Item name="description" label={t('Description')}>
                <Input.TextArea rows={3} placeholder={t('Description')} />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                <Space>
                    <Button onClick={onCancel}>{t('Cancel')}</Button>
                    <Button
                        type="primary"
                        danger
                        onClick={handleSubmit}
                        loading={loading}
                        disabled={!currentTimeout}
                    >
                        {t('Set Priority')}
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    );
}
